import { Component, Input } from '@angular/core';

export interface NoteItem {
  text: string;
  createdOn: string;
  createdBy?: string;
}

@Component({
  selector: 'wm-notes',
  standalone: false,
  templateUrl: './notes-janus.component.html',
  styleUrls: ['./notes-janus.component.scss']
})
export class NotesJanusComponent {

  @Input() applicationId!: string;
  @Input() applicationNumber!: string;
  isLoading = false;

  ngOnChanges(): void {
    this.isLoading = !!this.applicationId && !this.applicationNumber;
  }

}